<template>
  <button
    type="button"
    class="events-calendar-filter__trigger btn btn-secondary btn-medium"
    aria-label="Фильтр"
    @click="filterOpen = true"
  >
    <FilterIcon :filled="isFilterApplied" />
  </button>

  <EventsCalendarFilterDrawer v-model:open="filterOpen" @applied="handleApplied" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import FilterIcon from '@/js/components/icons/FilterIcon.vue';
import EventsCalendarFilterDrawer from './EventsCalendarFilterDrawer.vue';
import {
  getEventsCalendarScope,
  hasActiveEventsCalendarDrawerFilters,
} from './sync-filters';

const filterOpen = ref(false);
const filtersRevision = ref(0);

const isFilterApplied = computed(() => {
  filtersRevision.value;

  return hasActiveEventsCalendarDrawerFilters(getEventsCalendarScope());
});

function handleApplied(): void {
  filtersRevision.value += 1;
}
</script>
